<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Accounts</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home
            </router-link>
            <span class="breadcrumb-item active">Accounts</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Username</th>
                    <th>Email</th>
                    <th>Status</th>
                    <th>Incoming Date</th>
                    <th>Closed Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="help in helps" :key="help.id">
                    <td>{{help.id}}</td>
                    <td>{{help.username}}</td>
                    <td>{{help.email}}</td>
                    <td class="checkbox-icon pt-0 disabled-click">
                      <label class="checkbox-container">
                        <input :checked="help.is_closed" type="checkbox">
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td>{{help.created_at}}</td>
                    <td>{{help.closed_date}}</td>
                    <td>
                      <i class="fa fa-pencil-alt fa-icons ml-md-3" @click="editedHelp = JSON.parse(JSON.stringify(help))" aria-hidden="true" data-toggle="modal" data-target="#edit-modal"></i>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Wrapper END -->
    <!-- <HelpModal></HelpModal> -->
    <EditHelpModal v-if="editedHelp" :help="editedHelp" :key="editedHelp.id"></EditHelpModal>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import EditHelpModal from '@/components/EditHelpModal'
import Help from '@/models/help'
export default {
  name: 'Accounts',
  components: {
    // HelpModal,
    EditHelpModal
  },
  data () {
    return {
      datatable: null,
      helps: [],
      editedHelp: null
    }
  },
  computed: {
    isLoading () {
      if (this.helps.length === 0) { return this.$store.getters.apiStatus === 'loading' } else return false
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)
    this.fetchAllHelps()
  },
  methods: {
    fetchAllHelps () {
      this.helps = []
      this.$store.dispatch('fetchAllHelps')
        .then((result) => {
          result.data.helps.forEach(help => {
            this.helps.push(new Help(help))
          })
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        stateSave: true,
        pagingType: 'full_numbers',
        columnDefs: [{
          targets: 4,
          'orderable': false
        }],
        stateSaveCallback: function (settings, data) {
          localStorage.setItem('DataTables_accounts_page', JSON.stringify(data))
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_accounts_page'))
        },
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Helps.vue